
export interface CountryDataType {
    iso_3166_1_a2: string,
    printable_name: string,
}
export interface StateDataType {
    id_region1: string,
    codigo31662: string,
    nombre: string,
}
export interface DistritDataType {
    id_region2: string,
    codigoHASC: string,
    nombre: string,
}
export interface CityDataType {
    id_localidad: number,
    codigo_postal: number | string,
    cp_codigo31662: string,
    nombre: string,
}

export interface Address {
    id?: number;
    first_name: string;
    last_name: string;
    street: string;
    addr_detail?: string;
    city?: number | string;
    state?: number | string;
    postcode?: number | string;
    country?: string;
    notes?: string;
    phone_number?: string;
    verbose?: {
        city: string;
        state: string;
        postcode: number | string;
        country: string;
    };

    [key: string]: string | number | object | undefined;  // Añade esta línea para permitir el acceso dinámico
}

export const initAddress = {
    first_name: '',
    last_name: '',
    street: '',
    country: 'AR',
    verbose: {
        city: '',
        state: '',
        postcode: '',
        country: 'Argentina',
    },
};

export type Level = 'country' | 'state' | 'city';

export interface MapMarker {
    id: string | number;
    code?: string | number;
    codes?: string[];    // solo en level='city'
    level: Level;
    label: string;
    lat: number;
    lng: number;
    data?: any;  // eslint-disable-line @typescript-eslint/no-explicit-any
}

export interface SelectedValue {
    id?: string | number;
    code?: string | number;
    codes?: string[];
    level: Level;
    label: string;
    lat?: number;
    lng?: number;
}
